import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationNewsCreated = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новая новость</div>
            <div className={'vm-notification__description'}>
                Добавлена новая новость <UiNavLink to={ROUTES.NEWS(notification.data.news.id)} onClick={onClose}>{notification.data.news.name}</UiNavLink>
            </div>
        </div>
    );
});
